import {all, put, takeEvery, select, delay, call} from "redux-saga/effects";
import jwt from "jsonwebtoken";
import Http from "../commons/utils/Http";
import urlParameters from "../commons/utils/urlParameters"
import Utils from '../commons/utils/utils'

import {setUserData, setUserPermissions, setUserScreens, setFirstAccess} from "../store/actions/userLoginActions";
import {setAppLoading} from "../store/actions/appLoadingActions";
import {toast} from "react-toastify";

function callGetPermissionsApi(userId) {
    return Http.get(`/users/get-module?app_id=2&user_id=${userId}`, Http.headers)
}

function callGetUserData(userId) {
    return Http.get(`/users/get-by?field=id&value=${userId}`, Http.headers)
}

function* getToken() {
    const token = window.localStorage.token;
    if (token) {
        return token;
    } else {
        yield delay(100);
        return yield getToken();
    }
}

function* handleInitApp() {
    yield put(setAppLoading(true));
    const token = yield call(getToken);
    const tokenData = jwt.decode(token);
    yield put(setUserData(tokenData));

    try {
        const state = yield select();
        const userId = state.userLogin.userData.id;
        const responseGetPermissions = yield call(callGetPermissionsApi, userId);
        yield put(setUserPermissions(responseGetPermissions.data.data));

        const {modules} = responseGetPermissions.data.data[0];
        const screens = [];

        modules.map(module => {
            if (module.screen) {  
                screens.push({screen_name: module.screen_name, url: module.url, functions: module.functions});
            }
        });

        yield put(setUserScreens(screens));

        const responseGetUserData = yield call(callGetUserData, userId);
        yield put(setFirstAccess(responseGetUserData.data.data.first_access));

    } catch (e) {
        toast.error("Erro ao buscar permissões do usuário");
    }

    yield put(setAppLoading(false))    
}


export function* watchAppActions() {
    yield all([
        takeEvery("INIT_APP", handleInitApp)
    ])
}
